import React from 'react'
import Image from 'next/image'
import styled from 'styled-components'

const NavigationButton = styled.button`
  border: none;
  box-shadow: ${({ theme }) => theme.defaultBoxShadow};
  border-radius: 15px;
  padding: 0.5rem;
  margin: 0.25rem;
  color: ${({ primary }) => (primary ? 'white' : 'black')};
  background-color: ${({ primary, theme }) => (primary ? theme.colors.primary : 'white')};
  display: inline-flex;
  align-items: center;
`

const NavigationArea = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  z-index: ${({ theme }) => theme.zindex.navigationButtons}; ;
`

const NavigationOverlay = ({ handleClose, launchGoogleMaps }) => (
  <NavigationArea>
    <div className='text-center mb-2'>
      <NavigationButton title='Knop sluit navigatie' onClick={handleClose} primary>
        <Image alt='Icoon van kruis' src='/assets/icons/no-check.svg' width={16} height={16} />
        <span className='ms-2'>Sluit route</span>
      </NavigationButton>
      <NavigationButton title='Knop navigeer hierheen' onClick={launchGoogleMaps}>
        <Image
          alt='Icoon van navigatiepijl'
          src='/assets/icons/navigation.svg'
          width={16}
          height={16}
        />
        <span className='ms-2'>Open Google Maps</span>
      </NavigationButton>
    </div>
  </NavigationArea>
)

export default NavigationOverlay
